import React from 'react';
import { Card, Skeleton, Empty } from 'antd';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceDot } from 'recharts';

export default function PriceHistoryChart({ data, loading, height = 200 }) {
  if (loading) {
    return (
      <Card style={{ borderRadius: 12 }}>
        <Skeleton active paragraph={{ rows: 3 }} />
      </Card>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Card style={{ borderRadius: 12 }}>
        <Empty description="No price history available" image={Empty.PRESENTED_IMAGE_SIMPLE} />
      </Card>
    );
  }

  const formatted = data.map((d) => ({
    date: new Date(d.observedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    price: d.priceMinor / 100,
  }));

  const prices = formatted.map((d) => d.price);
  const minPrice = Math.min(...prices);
  const maxPrice = Math.max(...prices);
  const padding = (maxPrice - minPrice) * 0.1 || 10;

  const latestPrice = formatted[formatted.length - 1].price;
  const lowestPrice = minPrice;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={formatted} margin={{ top: 10, right: 20, left: 20, bottom: 10 }}>
        <XAxis
          dataKey="date"
          tick={{ fontSize: 11, fill: '#94a3b8' }}
          axisLine={false}
          tickLine={false}
          padding={{ left: '1%' }}
        />
        <YAxis
          domain={[minPrice - padding, maxPrice + padding]}
          tick={{ fontSize: 11, fill: '#94a3b8' }}
          tickFormatter={(v) => `$${v.toFixed(0)}`}
          axisLine={false}
          tickLine={false}
        />
        <Tooltip
          formatter={(value) => [`$${value.toFixed(2)}`, 'Price']}
          contentStyle={{ borderRadius: 8, border: '1px solid #e2e8f0', background: '#ffffff' }}
          labelStyle={{ fontSize: 12, color: '#64748b' }}
          itemStyle={{ fontSize: 12 }}
        />
        <Line
          type="monotone"
          dataKey="price"
          stroke="#1e40af"
          strokeWidth={2}
          dot={{ r: 0 }}
          activeDot={{ r: 5, fill: '#1e40af' }}
        />
        {latestPrice === lowestPrice && formatted.length > 1 && (
          <ReferenceDot
            x={formatted[formatted.length - 1].date}
            y={lowestPrice}
            r={5}
            fill="#10b981"
            stroke="#ffffff"
            strokeWidth={2}
          />
        )}
      </LineChart>
    </ResponsiveContainer>
  );
}
